<div
    class="avi-main-header"
    *permissionCheck="'UI_NAVBAR'"
>
    <branding></branding>
    <ng-container *permissionCheck="'UI_USER_MENU'">
        <avi-main-header-controller-site-selector *permissionCheck="'PERMISSION_CONTROLLERSITE'"></avi-main-header-controller-site-selector>
    </ng-container>
    <div class="avi-main-header__empty-section"></div>
    <avi-main-header-tenant-selector
        *ngIf="!hideTenantSelector"
        class="avi-main-header__tenant-selector"
    ></avi-main-header-tenant-selector>
    <cds-divider
        orientation="vertical"
        class="avi-main-header__divider"
    ></cds-divider>
    <avi-main-header-user-menu-container *permissionCheck="'UI_USER_MENU'"></avi-main-header-user-menu-container>
</div>
